const FE_Tabs = Object.freeze({
  Inventory: 1,
  MyRequests: 2,
  ReviewRequests: 3,
});
export default FE_Tabs;
